import Box from "ds/components/Box";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";

import { CellComponentProps } from "../types";

type IdpGroupRolesListItemDescriptionCellProps = CellComponentProps;

const IdpGroupRolesListItemDescriptionCell = ({
  roleBinding,
}: IdpGroupRolesListItemDescriptionCellProps) => {
  if (!roleBinding.role.description) {
    return null;
  }

  return (
    <Box direction="row" align="center">
      <ListEntitiesItemDescriptionMultipleLines
        lines={1}
        hasChevronLink
        description={roleBinding.role.description}
      />
    </Box>
  );
};

export default IdpGroupRolesListItemDescriptionCell;
